import AsyncStorage from "@react-native-async-storage/async-storage";
import {
	AlertDialog,
	Box,
	Button,
	Heading,
	ScrollView,
	Stack,
	useMediaQuery,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, Image, Platform, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

// API
import ErrorToast from "../../components/ErrorToast";
import Loader from "../../components/Loader";
import SuccessToast from "../../components/SuccessToast";
import { isWeb } from "../../utils/utils";
import delete_account from "../../../assets/delete_account.png";
import deleteAccount from "../../common/deleteAccount";
import { removeAuth } from "../../redux/slices/LoginSlice";
import Caution from "../../../assets/caution.png";

const { width, height } = Dimensions.get("window");

const DeleteAccount = ({ navigation, route }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [isSubmitting, setIsSubmitting] = useState(false);
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = React.useState(false);
	const onClose = () => setIsOpen(false);
	const cancelRef = React.useRef(null);

	const Auth = useSelector((state) => state.Login.Auth);
	const page = useSelector((state) => state.Page.Pages);
	const isPageLoading = useSelector((state) => state.Page.loading);

	const handleDeleteAccount = async (type) => {
		try {
			if (type === "delete") {
				setIsOpen(!isOpen);
			} else {
				navigation.navigate("Main Menu");
			}
		} catch (error) {
			console.log(error);
			setIsSubmitting(false);
			console.log(error.data);
			if (error.data?.error) {
				ErrorToast(error.data.error);
			} else {
				ErrorToast(error.message);
			}
		}
	};

	const deleteMemberAccount = async () => {
		try {
			let results = await deleteAccount(
				Auth.session_token,
				Auth.storemember_guid
			);

			SuccessToast("Account successfully deleted");
			onClose();

			dispatch(removeAuth());
			AsyncStorage.removeItem("auth");
			navigation.navigate("Main Menu");
		} catch (error) {
			console.log(error);
			setIsSubmitting(false);
			console.log(error.data);
			if (error.data?.error) {
				ErrorToast(error.data.error);
			} else {
				ErrorToast(error.message);
			}
		}
	};

	const cancelDialog = () => {
		onClose();
		navigation.navigate("Main Menu");
	};

	const componentGenerator = (control) => {
		if (control.componenttype_name === "BUTTON") {
			return (
				<View key={control.datatype_label} style={{ margin: 2 }}>
					<Button
						onPress={() =>
							handleDeleteAccount(control.sitepagecomponent_meta.type)
						}
						isLoading={isSubmitting}
						isLoadingText="Submitting"
						colorScheme={
							control.sitepagecomponent_meta.type == "delete"
								? "danger"
								: "success"
						}
						variant={isSubmitting ? "outline" : "solid"}
						style={
							isDesktopOrLaptop[0]
								? {
										marginLeft: "auto",
										marginRight: "auto",
								  }
								: {}
						}
					>
						{control.sitepagecomponent_meta.altLabel}
					</Button>
				</View>
			);
		} else if (control.componenttype_name === "TEXT") {
			return (
				<View
					key={control.datatype_label}
					style={{ padding: 10, margin: 5, textAlign: "center" }}
				>
					<Heading fontWeight="400" size="sm" color="primary.500">
						{control.sitepagecomponent_meta.delete_message}
					</Heading>
				</View>
			);
		}
	};

	return (
		<>
			{isPageLoading ? (
				<Loader />
			) : (
				<ScrollView>
					<Box
						bg="#fff"
						padding="20px"
						borderRadius="5px"
						flex="3"
						margin="5px"
					>
						<Stack mx="3" space={2.5} padding="10px">
							<View
								style={{
									padding: 5,
									borderRadius: 5,
								}}
							>
								<Image
									resizeMode="contain"
									source={{
										uri: isWeb()
											? delete_account
											: Image.resolveAssetSource(delete_account).uri,
									}}
									style={{
										width: isWeb() ? width / 2 : width,
										height: isWeb() ? height / 2 : height / 3,
										marginTop: isWeb() ? 0 : 10,
										alignSelf: "center",
									}}
								/>
							</View>
							{page[0]?.children_components.map((control, index) =>
								componentGenerator(control)
							)}
						</Stack>
						<AlertDialog
							leastDestructiveRef={cancelRef}
							isOpen={isOpen}
							onClose={onClose}
						>
							<AlertDialog.Content>
								<AlertDialog.CloseButton />
								<AlertDialog.Header>Delete Your Profile</AlertDialog.Header>
								<AlertDialog.Body>
									<View
										style={{
											padding: 5,
											borderRadius: 5,
										}}
									>
										<Image
											resizeMode="contain"
											source={{
												uri: isWeb()
													? Caution
													: Image.resolveAssetSource(Caution).uri,
											}}
											style={{
												width: 150,
												height: 150,
												marginTop: isWeb() ? 0 : 10,
												marginBottom: 15,
												alignSelf: "center",
											}}
										/>
									</View>
									{`This will remove all data relating to ${
										Auth.profile.data.filter(
											(profile) => profile.type_name === "first_name"
										)[0]?.data_text
									} ${
										Auth.profile.data.filter(
											(profile) => profile.type_name === "second_name"
										)[0]?.data_text
									}. This action cannot be reversed. Deleted data can not be recovered! \n\nAre you sure you want to delete your profile?`}
								</AlertDialog.Body>
								<AlertDialog.Footer>
									<Button.Group space={2}>
										<Button
											variant="unstyled"
											colorScheme="coolGray"
											onPress={cancelDialog}
											ref={cancelRef}
										>
											Cancel
										</Button>
										<Button colorScheme="danger" onPress={deleteMemberAccount}>
											Delete
										</Button>
									</Button.Group>
								</AlertDialog.Footer>
							</AlertDialog.Content>
						</AlertDialog>
					</Box>
				</ScrollView>
			)}
		</>
	);
};

export default DeleteAccount;
